export const environment = {
  production: false,
  staging: true,
  development: false,
  apiBaseUrl: 'https://staging-api.agrigateone.com',
  webSocketUrl: 'wss://staging-api.agrigateone.com/cable',
  authentication: {
    auth0Domain: 'agrigate-dev.eu.auth0.com',
    clientID: 'L3xaVVeBBc2T7CgUKzfKMZmxNxDCMbUL',
    redirectURI: 'https://staging-app.agrigateone.com/login/callback',
    audience: 'https://api-dev.agrigate.com',
    webappUrl: 'https://staging-app.agrigateone.com',
    logoutUrl: 'https://staging-app.agrigateone.com/login',
  },
  sentry: {
    environment: 'staging',
    dsn: 'https://f992693bf9654428972bd8968d2a13fa@sentry.io/1365705',
    logToSentry: true,
  },
  freshdesk: {
    domain: 'agrigate',
  },
  gcp: {
    maps: {
      apiKey: 'AIzaSyBiJXMwNwB83uBb5yyaN-P6CamuCA-6ZOE',
    },
    places: {
      apiKey: 'AIzaSyAdV0KTUiGnsdWTzFAlyNU-NVpi4FU09Hk',
    },
  },
  mixpanelEnabled: true,
  mixpanelToken: '28461d0a3eb48975eaf2a79f9097d2fc',
  cartoAPIKey: 'cb1_2asj_1_993dbbccb99d7e0c0655dfa8',
};
